/* Submenus do tema; a abertura do menu mobile principal permanece no florescer-home.js. */
(() => {
  function init(root) {
    if (root.dataset.fsNavReady) return;
    root.dataset.fsNavReady = '1';
    const desktop = [...root.querySelectorAll('.fl-header__desktop > details')];
    const mobile = [...root.querySelectorAll('.fl-header__mobile > ul > li > details')];
    const close = (groups) => groups.forEach((group) => { group.open = false; });
    desktop.forEach((group) => group.addEventListener('toggle', () => {
      if (group.open) desktop.filter((other) => other !== group).forEach((other) => { other.open = false; });
    }));
    mobile.forEach((group) => group.addEventListener('toggle', () => {
      if (group.open) mobile.filter((other) => other !== group).forEach((other) => { other.open = false; });
    }));
    document.addEventListener('click', (event) => { if (!root.contains(event.target)) close(desktop); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(desktop); close(mobile); root.querySelectorAll('.fl-header__mobile details details').forEach((group) => { group.open = false; }); } });
    root.querySelector('[data-fl-menu-button]')?.addEventListener('click', () => { close(mobile); });
  }
  const start = () => document.querySelectorAll('florescer-header').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();